import { getTransactionAnalytics } from '@ynap/analytics';
import { CheckoutAnalytics } from '../@types';

export const addressSearchStarted = (primaryCategory = 'checkout', checkoutAnalytics?: CheckoutAnalytics) => {
    return {
        event: 'address search started',
        effect: 'start address search',
        category: {
            primaryCategory,
            subCategory: 'shipping address',
        },
        ...(checkoutAnalytics ? { transaction: getTransactionAnalytics(checkoutAnalytics) } : {}),
    };
};

export const addressSearchResults = (primaryCategory = 'checkout', checkoutAnalytics?: CheckoutAnalytics) => ({
    event: 'address search results displayed',
    effect: 'list of results found',
    category: {
        primaryCategory,
        subCategory: 'shipping address',
    },
    ...(checkoutAnalytics ? { transaction: getTransactionAnalytics(checkoutAnalytics) } : {}),
});

export const addressSearchNoResults = (primaryCategory = 'checkout', checkoutAnalytics?: CheckoutAnalytics) => ({
    event: 'address search - no results found',
    effect: 'results not found',
    category: {
        primaryCategory,
        subCategory: 'shipping address',
    },
    ...(checkoutAnalytics ? { transaction: getTransactionAnalytics(checkoutAnalytics) } : {}),
});

export const addressSearchSelected = (primaryCategory = 'checkout', checkoutAnalytics?: CheckoutAnalytics) => ({
    event: 'address selected',
    effect: 'click on suggested address',
    category: {
        primaryCategory,
        subCategory: 'shipping address',
    },
    ...(checkoutAnalytics ? { transaction: getTransactionAnalytics(checkoutAnalytics) } : {}),
});

export const addressSearchManually = (primaryCategory = 'checkout', checkoutAnalytics?: CheckoutAnalytics) => ({
    event: 'address manually entered',
    effect: 'click to enter address manually',
    category: {
        primaryCategory,
        subCategory: 'shipping address',
    },
    ...(checkoutAnalytics ? { transaction: getTransactionAnalytics(checkoutAnalytics) } : {}),
});
